import {
  Box,
  FormControl,
  FormHelperText,
  FormLabel,
  Paper,
  Slider,
  Grid
} from "@mui/material";
// import Grid from "@mui/material/Unstable_Grid2";
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { NumericFormat } from "react-number-format";
import InfoPopover from "../components/InfoPopover.jsx";

SliderInput.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  showErrorText: PropTypes.bool,
  variant: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool,
};

export default function SliderInput(props) {
  const {
    item,
    value,
    error = null,
    onChange,
    showErrorText = false,
    variant = "filled",
    size = "small",
    disabled = false,
  } = props;
  const [localValue, setLocalValue] = useState(value);

  const handleInputChange = (newValue) => {
    setLocalValue(newValue.floatValue);
  };

  useEffect(() => {
    setLocalValue(value);
  }, [value]);

  const handleSliderChange = (e) => {
    setLocalValue(e.target.value);
  };

  const handleBlur = () => {
    let newValue = localValue;
    if (newValue !== "undefined") {
      if (newValue < item.min) newValue = item.min;
      if (newValue > item.max) newValue = item.max;
    } else newValue = item.default;
    setLocalValue(newValue);
    onChange({ target: { name: item.name, value: newValue } });
  };

  let helperText = "";
  if (showErrorText) helperText = error;

  const getInputField = () => {
    switch (item.unit_type) {
      case "currency_no_digit":
        return (
          <NumericFormat
            style={{ textAlign: "right", width: "100%" }}
            displayType="input"
            disabled={disabled}
            allowNegative={true}
            value={localValue}
            onValueChange={handleInputChange}
            onBlur={handleBlur}
            suffix={" " + item.unit}
            thousandsGroupStyle="thousand"
            decimalSeparator=","
            thousandSeparator="."
          />
        );
      case "percent":
        return (
          <NumericFormat
            style={{ textAlign: "right", width: "100%" }}
            disabled={disabled}
            allowNegative={true}
            decimalScale={2}
            value={localValue}
            decimalSeparator=","
            onValueChange={handleInputChange}
            onBlur={handleBlur}
            suffix={" " + item.unit}
          />
        );
      case "integer":
        return (
          <NumericFormat
            style={{ textAlign: "right", width: "100%" }}
            disabled={disabled}
            allowNegative={true}
            className="form-control mt-0"
            value={localValue}
            onValueChange={handleInputChange}
            onBlur={handleBlur}
            suffix={" " + item.unit}
          />
        );
      default:
    }
  };

  return (
    <Paper
      elevation={0}
      sx={{
        borderStyle: "solid",
        borderWidth: "1px",
        borderColor: "#E6E6E6",
        backgroundColor: "rgba(0, 0, 0, 0.06)",
        height: "100%",
        width: "100%",
        pl: "10px",
        pr: "30px",
        pt: "5px",
        pb: "10px",
        margin: (props.margin || 0) + "px",
      }}
    >
      <FormControl
        variant={variant}
        {...(error && { error: true })}
        sx={{ width: "100%" }}
        size={size}
      >
        <Box
          display="flex"
          flexDirection="column"
          alignItems="flex-start"
          sx={{ mt: "10px", mb: "5px" }}
        >
          <Box display="flex" alignItems="start" justifyContent="space-between">
            <FormLabel>{item.label}</FormLabel>
            <InfoPopover item={item} />
          </Box>
        </Box>
        <Grid container="true" spacing={2}>
          <Grid
            sx={{ paddingTop: "2px", pl: "15px", pr: "15px" }}
            size={{
              md: 3,
              xs: 12,
              lg: 3,
              sm: 4
            }}
          >
            {getInputField()}
          </Grid>
          <Grid sx={{ padding: "0px" }} size={{
            md: 9,
            xs: 12,
            lg: 9,
            sm: 8
          }}>
            <Slider
              disabled={disabled}
              value={localValue}
              min={item.min}
              max={item.max}
              step={item.step}
              onChange={handleSliderChange}
              onChangeCommitted={handleBlur}
              aria-labelledby="input-slider"
            />
          </Grid>
        </Grid>
        <FormHelperText>{helperText}</FormHelperText>
      </FormControl>{" "}
    </Paper>
  );
}
